import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-932b492a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "forgot-password-view bg-image-md d-flex flex-column justify-content-center align-items-center col-12 py-3 py-md-5" }
const _hoisted_2 = { class: "col-12 d-flex p-2 p-md-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-primary d-none d-md-block col-1 col-lg-2 col-xl-3" }, null, -1))
const _hoisted_4 = { class: "bg-primary col-12 col-md-10 col-lg-8 col-xl-6 p-3 p-md-5 flex-centered-col bg-image" }
const _hoisted_5 = {
  style: {"max-width":"640px"},
  class: "col-12 rounded shadow bg-light px-3 px-md-5 py-3 py-md-4"
}
const _hoisted_6 = {
  key: 0,
  class: "col-12 m-0 mb-4 text-uppercase"
}
const _hoisted_7 = {
  key: 1,
  class: "col-12 m-0 mb-4 text-uppercase"
}
const _hoisted_8 = { class: "col-12 form py-1" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center text-sm-start" }, " A password reset email has been sent to your email address. Please click the link in the email to proceed with your password reset. ", -1))
const _hoisted_11 = [
  _hoisted_10
]

import ForgotPasswordForm from "@/components/forms/ForgotPasswordForm.vue";
import { onBeforeMount, reactive, ref, Ref } from "vue";
import { useHead } from "@unhead/vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordView',
  setup(__props) {

useHead({
  title: "Forgot Password",
});

const route = useRoute();
let code: Ref<string | null> = ref(null);
let email: Ref<string | null> = ref(null);
let done: Ref<boolean> = ref(false);

onBeforeMount(() => {
  if (route.query.code != null) {
    code.value = decodeURI(route.query.code as string);
  }

  if (route.query.email) {
    email.value = route.query.email as string;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_unref(done))
            ? (_openBlock(), _createElementBlock("h1", _hoisted_6, " Password reset Sent "))
            : (_openBlock(), _createElementBlock("h1", _hoisted_7, "Reset password")),
          _createElementVNode("div", _hoisted_8, [
            (!_unref(done))
              ? (_openBlock(), _createBlock(ForgotPasswordForm, {
                  key: 0,
                  code: _unref(code),
                  email: _unref(email),
                  onDone: _cache[0] || (_cache[0] = ($event: any) => (_isRef(done) //@ts-ignore
 ? done.value = true : done = true))
                }, null, 8, ["code", "email"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          ])
        ])
      ])
    ])
  ]))
}
}

})